const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

if (!API_BASE_URL) {
  throw new Error("REACT_APP_API_BASE_URL is not defined");
}

export const getApiUrl = (path) => {
  const normalizedBaseUrl = API_BASE_URL.endsWith("/")
    ? API_BASE_URL
    : `${API_BASE_URL}/`;

  return `${normalizedBaseUrl}${path.replace(/^\//, "")}`;
};
